import { AuditCard } from "@/features/Audit/AuditCard";
import { Tables } from "@/gen/tableNames/tables";
import i18n from "@/i18n";
import { Clients } from "@/lib/clients";
import { useParams } from "react-router-dom";
import { S1PositionsEditCard } from "./edit_card";
import { TechnicalInfoCard } from "@/components/TechnicalInfoCard";

export const S1PositionsCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full relative">
      <div className="flex flex-col gap-10 p-10">
        <S1PositionsEditCard id={Number(id)} />
        <TechnicalInfoCard
          id={Number(id)}
          table_name={Tables.S1_POSITIONS}
          client={Clients.S1_QUANTILIA}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.S1_QUANTILIA}
          audit_table_name={Tables.S1_POSITIONS}
        />
      </div>
    </div>
  );
};
